import { parse } from 'graphql';

// Codegen emits types from the matching source operations. These parsed documents
// are the Field Ops operations sent by the authenticated dashboard client.
export const CREATE_SEED_DATA_UPLOAD_DOCUMENT = parse(/* GraphQL */ `
  mutation CreateSeedDataUpload($input: CreateSeedDataUploadInput!) {
    createSeedDataUpload(input: $input) {
      import {
        id
        originalFilename
        status
        expiresAt
        householdOutcomes {
          created
          updated
          existingUnchanged
          total
        }
        voterOutcomes {
          created
          updated
          existingUnchanged
          total
        }
      }
      uploadUrl
      uploadUrlExpiresAt
    }
  }
`);

export const CONFIRM_SEED_DATA_UPLOAD_DOCUMENT = parse(/* GraphQL */ `
  mutation ConfirmSeedDataUpload($id: ID!) {
    confirmSeedDataUpload(id: $id) {
      id
      originalFilename
      status
      expiresAt
      householdOutcomes {
        created
        updated
        existingUnchanged
        total
      }
      voterOutcomes {
        created
        updated
        existingUnchanged
        total
      }
    }
  }
`);

export const CANCEL_SEED_DATA_UPLOAD_DOCUMENT = parse(/* GraphQL */ `
  mutation CancelSeedDataUpload($id: ID!) {
    cancelSeedDataUpload(id: $id) {
      id
      originalFilename
      status
      expiresAt
      householdOutcomes {
        created
        updated
        existingUnchanged
        total
      }
      voterOutcomes {
        created
        updated
        existingUnchanged
        total
      }
    }
  }
`);

export const RETRY_SEED_DATA_IMPORT_DOCUMENT = parse(/* GraphQL */ `
  mutation RetrySeedDataImport($id: ID!) {
    retrySeedDataImport(id: $id) {
      id
      originalFilename
      status
      expiresAt
      attempts
      householdOutcomes {
        created
        updated
        existingUnchanged
        total
      }
      voterOutcomes {
        created
        updated
        existingUnchanged
        total
      }
    }
  }
`);

export const SEED_DATA_IMPORTS_DOCUMENT = parse(/* GraphQL */ `
  query SeedDataImports($limit: Int!, $offset: Int!) {
    seedDataImports(limit: $limit, offset: $offset) {
      total
      items {
        id
        originalFilename
        status
        sizeBytes
        processedRows
        importedRows
        skippedRows
        warningRows
        householdsUpserted
        votersUpserted
        householdOutcomes {
          created
          updated
          existingUnchanged
          total
        }
        voterOutcomes {
          created
          updated
          existingUnchanged
          total
        }
        attempts
        errorReportAvailable
        pollingRecommended
        createdAt
        processingStartedAt
        completedAt
      }
    }
  }
`);

export const SEED_DATA_ERROR_REPORT_URL_DOCUMENT = parse(/* GraphQL */ `
  query SeedDataErrorReportUrl($id: ID!) {
    seedDataErrorReportUrl(id: $id) {
      url
      expiresAt
    }
  }
`);
